// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b9f0n","subtitle":"styles_subtitle__TG6N9","successModal":"styles_successModal__3173J","errorModal":"styles_errorModal__SpFLA"};